var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-carousel",
        {
          attrs: {
            classs: "t-form-carousel",
            height: (_vm.config.height ? _vm.config.height : 300) + "px",
            interval: _vm.config.interval * 1000 || 5000,
            "indicator-position": "none",
          },
          on: { change: _vm.changeCarousel },
        },
        _vm._l(_vm.carouselOptions, function (option, index) {
          return _c(
            "el-carousel-item",
            { key: index },
            [
              _c("p", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.item.label)),
              ]),
              _c("el-image", {
                staticStyle: { width: "100%" },
                style: {
                  height: (_vm.config.height ? _vm.config.height : 300) + "px",
                },
                attrs: { fit: _vm.config.imageFit, src: option.image },
              }),
            ],
            1
          )
        }),
        1
      ),
      _c("div", { staticClass: "t-carousel-indicator" }, [
        _c("div", { staticClass: "indicator-box" }, [
          _vm._v(
            _vm._s(_vm.curIndex + 1) + "/" + _vm._s(_vm.carouselOptions.length)
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }